var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgPaperBookmarkLock(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M20.038 3.738v7.5a.5.5 0 11-1 0V4.737h-8.563L6.737 8.475v12.658h6.5a.5.5 0 010 1.001H5.739V8.372l.038-.191.073-.177.109-.162 3.884-3.884.162-.109.177-.073.19-.038h9.667zm-7.514 13.815c.278 0 .417.22.412.436.004.192-.105.387-.324.428l-.088.008H9.212c-.277 0-.416-.22-.412-.436-.005-.216.134-.436.412-.436h3.312zm3.986-2c.278 0 .418.22.412.436.005.192-.105.387-.324.428l-.088.008H9.212c-.277 0-.416-.22-.412-.436-.005-.216.134-.436.412-.436h7.298zM21 13c1.838 0 3.333 1.458 3.333 3.25v1.625h.417c.689 0 1.25.547 1.25 1.219v5.687c0 .672-.561 1.219-1.25 1.219h-7.5c-.689 0-1.25-.547-1.25-1.219v-5.687c0-.672.561-1.219 1.25-1.219h.416V16.25c0-1.792 1.496-3.25 3.334-3.25zm3.75 5.688h-7.5a.412.412 0 00-.417.406v5.687c0 .224.188.407.417.407h7.5c.23 0 .417-.183.417-.407v-5.687a.412.412 0 00-.417-.407zM21 20.041c.613 0 1.111.486 1.111 1.083 0 .454-.287.843-.694 1.004v1.298a.412.412 0 01-.417.406.412.412 0 01-.417-.406V22.13a1.085 1.085 0 01-.694-1.004c0-.597.498-1.083 1.111-1.083zm0 .812a.275.275 0 00-.278.271c0 .15.125.27.278.27a.275.275 0 00.278-.27c0-.15-.125-.27-.278-.27zm0-7.041c-1.378 0-2.5 1.093-2.5 2.437l-.001 1.625H23.5V16.25c0-1.344-1.122-2.438-2.5-2.438zm-4.49-.26c.278 0 .418.22.412.436.005.192-.105.387-.324.428l-.088.008H9.212c-.277 0-.416-.22-.412-.436-.005-.216.134-.436.412-.436h7.298zM16.4 6.8a.6.6 0 01.592.503L17 7.4v3.69a.6.6 0 01-.892.525l-.085-.058-1.024-.826-1.022.826a.6.6 0 01-.683.05l-.085-.061-.076-.078a.6.6 0 01-.124-.276L13 11.091V7.4a.6.6 0 01.503-.592L13.6 6.8h2.8zm-.4 1h-2v2.452l1-.806 1 .807V7.8z"
  }));
}

export default SvgPaperBookmarkLock;